<section class="">
  <div class="container">
      <div>
          <ol class="breadcrumb">
              <li class="breadcrumb-item"> <a routerLink="/dashboard-job">Home</a></li>
              <li class="breadcrumb-item active"> <a routerLink="/job-roles">Job Roles</a></li>
          </ol>
      </div>
      <h3 class="subheading flexcss">Job Roles</h3>
      <div class="row">
          <div *ngFor="let job of jobRoleList;" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12"
          routerLink="/seeall" [queryParams]="{ type: 'roles',extras:job.id}" >
              <div class="card-grid-2">
                  <div class="card-grid-2-image-left paddingTop"> 
                      <div class="right-info">
                          <p class="name-job" >{{job.name}}</p> 
                      </div>
                      <div class="arrow"><a><img src="assets/images/ic_arrow_next.svg"></a></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>